import { render, staticRenderFns } from "./Cidade.vue?vue&type=template&id=72331b94&"
import script from "./Cidade.vue?vue&type=script&lang=js&"
export * from "./Cidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports